module.exports = __webpack_public_path__ + "public/img/douyin.76740f92.jpg";